"use strict";
/**
 * This const stores all the default values that are to be shared by FE and BE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalBotPlayers = exports.UsernameLength = exports.TableCodeLength = void 0;
// The length of Table Code that can be entered from FE and generated by BE
exports.TableCodeLength = 4;
// The length of username that can be entered from FE
exports.UsernameLength = 15;
// Maximum number of bots that can join a Bot Table
exports.TotalBotPlayers = 4;
//# sourceMappingURL=const.js.map